import axios from "axios";

const UPLOAD_URL = process.env.REACT_APP_CLOUDINARY_UPLOAD_URL;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
const MAX_FILE_SIZE_MB = Number(process.env.REACT_APP_MAX_FILE_SIZE_MB) || 20; 
const MAX_IMAGE_SIZE_MB = 10;

const uploadFileToCloudinary = (file, onProgress = () => {}) => {
  if (!file) return Promise.reject(new Error("No file provided"));

  // Validate file size
  const fileSizeMB = file.size / (1024 * 1024);

  if (file.type.startsWith("image/") && fileSizeMB > MAX_IMAGE_SIZE_MB) {
    throw new Error("Image is too large (max 10MB)");
  }

  if (fileSizeMB > MAX_FILE_SIZE_MB) {
    throw new Error(
      `File too large. Max allowed size is ${MAX_FILE_SIZE_MB}MB`
    );
  }

  const allowedTypes = ["image/", "video/", "application/pdf"];

  const isAllowed = allowedTypes.some((type) => file.type.startsWith(type));
  if (!isAllowed) {
    console.warn("File type not explicitly allowed:", file.type);
    return Promise.reject(new Error("Unsupported file type"));
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);

  //AUTO DETECT FILE TYPE
  let resourceType = "image";
  if (file.type.startsWith("video/")) resourceType = "video";
  if (file.type === "application/pdf") resourceType = "auto";

  const controller = new AbortController();

  // Return a structured object with both upload and cancel capability
  const uploadPromise = axios
    .post(
      `${UPLOAD_URL.replace("/auto/upload", `/${resourceType}/upload`)}`,
      formData,
      {
        signal: controller.signal,
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onProgress(percent);
          }
        },
      }
    )
    .then((res) => ({
      url: res.data.secure_url,
      public_id: res.data.public_id,
      resource_type: res.data.resource_type,
    }))
    .catch((err) => {
      if (axios.isCancel(err)) {
        throw new Error("Upload cancelled by user");
      }
      throw new Error(err.message || "Upload failed");
    });

  return { uploadPromise, cancel: () => controller.abort() };
};

export default uploadFileToCloudinary;
